import React, { useEffect, useRef, useCallback } from 'react';
import { Link } from 'react-router-dom';
import ReactDOM from 'react-dom';
import {
  Icon,
  Table,
  Input,
  Button,
  Form,
  Divider,
  Tooltip,
  Statistic,
  Modal,
  Popover,
  Row,
  Col,
  InputNumber,
} from 'antd';
import { PopUp, Selection } from '../../common';
import message from '../message';
import InputNum from '../InputNum';
import { inventoryCal, formatToFixed, formatNumber, tableHeaderFixed } from '../../../utils/biz';
import { asserts, auth, generators, maths } from '../../../utils';
import { queryRemindNumber } from '../../../service/common';
import {
  getSpecialShouldCheck,
  getStockoutShoulePack,
  getSearchPageShouldPack,
  packCheck,
  saveToCart,
  saveSalesUomToCart,
} from '../../../service/addToCart';
import eventBus from '../../layout/Container/EventBus';
import Context from '../../layout/Container/Context';
import useSearchTableModel from './model';
import {
  getCustomCodeSelectPopupContainer,
  showCustomCodeDeleteConfirm,
} from '../customCodePop/useCustomCodePop';
import DrawlingModal from '../DrawlingModal';
import ImgsModal from '../ImgsModal';
import RemindModal from '../RemindModal';
import PreparatifsModal from '../PreparatifsModal';
import { useDidMount, useWillUnmount } from '../../use';
import { clone, includes, isNil, concat, keys, trim } from 'ramda';
import moment from 'moment';
import './index.less';

const { formatPrice, formatToFixed2 } = formatToFixed;
const { Column } = Table;
const { confirm } = Modal;
const { isExist } = asserts;
const { generatorObject } = generators;
const { mul } = maths;
const hasShop = `${process.env.TARGET}static/imgs/cartOrder/shop.svg`;
const noShop = `${process.env.TARGET}static/imgs/cartOrder/unShop.svg`;
const preOrderImg = `${process.env.TARGET}static/imgs/icon_yu.svg`;
const clockImg = `${process.env.TARGET}static/imgs/icon_clock.svg`;
const stockImg = `${process.env.TARGET}static/imgs/icon_stock.svg`;
const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

export default Form.create()(
  ({
    form,
    data,
    loading,
    pagination,
    favorite = [],
    stockList = [],
    isSpecialOffer,
    isIndustryZone,
    locale,
    mode,
    onTableChange,
    handleCollect,
    handleCustom,
    handleStock,
    searchValue,
    onRef,
  }) => {
    const { permission, principal, days, isSpecialUser } = React.useContext(Context);
    const [remindVisible, setRemindVisible] = React.useState(false); //有货提醒弹框
    const [prepareVisible, setPrepareVisible] = React.useState(false);
    const [dataSource, setDataSource] = React.useState([]);
    const [selectedItem, setSelectedItem] = React.useState({});
    const [number, setNumber] = React.useState(0); //设置有货提醒的人数
    const [prepareNumber, setPrepareNumber] = React.useState(0); // 设置备货提醒的人数
    const { isHavingInventory, isHavingPrice, isHavingCust } = permission;
    const { state, dispatch } = useSearchTableModel();
    const { getFieldDecorator, getFieldValue, resetFields, setFields } = form;
    const [currentKey, setCurrentKey] = React.useState(undefined);
    const [pageSize, setPageSize] = React.useState(pagination.pageSize);
    const isLoginIn = asserts.isExist(principal);
    const CALLSOURCE = mode === 'search' ? '2' : void 0;
    const {
      key,
      isOperation,
      collectVisible,
      customVisible,
      stockVisible,
      upStockVisible,
      modalVisible,
      activityVisible,
      qualityVisible,
      cartItemQtyVisible,
      record,
      isNew,
      collection,
      customCode,
      stockCode,
      stockCodeList,
      imgsModalVisible,
      imgs,
      sysList,
      currentUnPackFlag,
      customCodeAddOrEdit,
      newCustomCode,
      newCustomCodeList,
      editingCustomCodeItem,
      customQueryImitm,
      customCodeListLoading,
    } = state;
    // 阻止 Popconfirm 因 Select 下拉/删除确认框失焦误关闭
    const suppressCustomPopCloseRef = React.useRef(false);
    const customCodeAddOrEditRef = React.useRef(false);
    const editingCustomCodeItemRef = React.useRef(null);

    React.useEffect(() => {
      customCodeAddOrEditRef.current = customCodeAddOrEdit;
      editingCustomCodeItemRef.current = editingCustomCodeItem;
      if (customCodeAddOrEdit) {
        suppressCustomPopCloseRef.current = true;
      }
    }, [customCodeAddOrEdit, editingCustomCodeItem]);

    React.useEffect(() => {
      if (customCodeAddOrEdit && key !== undefined && !customVisible) {
        dispatch('updateState')({ customVisible: true });
      }
    }, [customCodeAddOrEdit, key, customVisible, dispatch]);

    const resetCustomCodePopGuards = () => {
      suppressCustomPopCloseRef.current = false;
      customCodeAddOrEditRef.current = false;
      editingCustomCodeItemRef.current = null;
    };

    useDidMount(() => {
      window.addEventListener('scroll', handleScroll);
      if (isLoginIn) dispatch('getSysConfig')();
    });

    const handleScroll = () => {
      tableHeaderFixed('searchTable', isSpecialOffer || isIndustryZone ? '0px' : '72px');
    };

    useWillUnmount(() => {
      window.removeEventListener('scroll', handleScroll);
    });

    useEffect(() => {
      if (onRef) {
        onRef({
          getDataSource() {
            return dataSource;
          },
        });
      }
    });

    React.useLayoutEffect(() => {
      setTimeout(() => {
        let len = dataSource.length === pageSize ? pageSize : dataSource.length;
        for (let i = 0; i < len; i++) {
          if (asserts.isExist(dataSource) && asserts.isExist(dataSource[i].instantMultiList)) {
            const row = document.querySelector(
              `.searchTable .ant-table-body .ant-table-tbody [data-row-key='${dataSource[i].rowKey}']`,
            );
            const reductionRow = document.querySelector(
              `.searchTable .ant-table-body .ant-table-tbody [data-row-key='${dataSource[i].rowKey}'] .reduction-box`,
            );

            if (row && !reductionRow) {
              let div = document.createElement('div');
              div.className = 'reduction-box';
              dataSource[i].instantMultiList.forEach((item) => {
                let div1 = document.createElement('div');
                div1.className = 'reduction';
                let p = document.createElement('p');
                p.className = 'reduction-title';
                let img = document.createElement('img');
                img.src = `${process.env.TARGET}static/imgs/screwHead.svg`;
                img.className = 'reduction-img';

                let span = document.createElement('span');
                span.className = 'reduction-desc';
                span.innerHTML = `${item.remark},截止日:${moment(item.endTime).format(
                  'YYYY-MM-DD',
                )}日`;
                p.appendChild(img);
                p.appendChild(span);
                div1.appendChild(p);
                div.appendChild(div1);
              });
              row.appendChild(div);
              row.classList.add('reduction-active');
              // let divHeight = div.clientHeight;
              // // 2 指的是marginbottom：2 ；clientHeight包含外边距
              // divHeight = maths.sub(div.clientHeight, maths.mul(2, Math.floor(divHeight / 30)));
              // // 20指的是文字描述的高度  假设存在div满减信息为多行的情况  需要单独定义行高 96为行高
              // if (divHeight > 30) {
              //   let height = maths.add(96, maths.mul(30, Math.floor(divHeight / 30)));
              //   row.style.height = `${height}px`;
              // } else {
              //   row.style.height = '96px';
              // }
            }
          }
          if (
            !isSpecialOffer &&
            !isIndustryZone &&
            asserts.isExist(dataSource) &&
            asserts.isExist(dataSource[i].custItemLabel)
          ) {
            const { custItemLabel, instantMultiList } = dataSource[i];
            let labelHtml = asserts.isExist(custItemLabel)
              ? custItemLabel.cateTopLabel && !custItemLabel.itemTopLabel
                ? custItemLabel.cateTopLabel
                : !custItemLabel.cateTopLabel && custItemLabel.itemTopLabel
                ? custItemLabel.itemTopLabel
                : custItemLabel.cateTopLabel && custItemLabel.itemTopLabel
                ? custItemLabel.cateTopLabel +
                  '<span style="width: 4px;display:block"></span>' +
                  custItemLabel.itemTopLabel
                : ''
              : '';
            if (labelHtml) {
              const row = document.querySelector(
                `.searchTable .ant-table-body .ant-table-tbody [data-row-key='${dataSource[i].rowKey}']`,
              );
              if (asserts.isExist(row)) {
                let tagDiv = document.createElement('div');
                tagDiv.className = 'tag-box';
                tagDiv.style.display = 'flex';
                tagDiv.style.top = asserts.isExist(instantMultiList) ? 16 : 0;
                tagDiv.innerHTML = labelHtml;
                row.appendChild(tagDiv);
                row.classList.add('tag-active');
              }
            }
            const { quality } = custItemLabel;
            if (asserts.isExist(quality)) {
              let row = document.querySelector(
                `.searchTable .ant-table-body .ant-table-tbody [data-row-key='${dataSource[i].rowKey}']`,
              );
              if (asserts.isExist(row)) {
                let { rowKey } = dataSource[i];
                let qualityDiv = document.createElement('div');
                qualityDiv.innerHTML = '';
                qualityDiv.id = `quality-box-${rowKey}`;
                qualityDiv.className = 'quality-box';
                // qualityDiv.className = 'quality-box';
                // let childSpan = document.createElement('div');
                // childSpan.className = 'quality-box-content';
                // childSpan.innerHTML = `品质: <span class=qualityTitle>${quality}</span>`;
                // qualityDiv.className = 'quality-box pointer';
                // qualityDiv.appendChild(childSpan);
                row.appendChild(qualityDiv);
                row.classList.add('quality-active');
                ReactDOM.render(
                  <AppendQualityDom custItemLabel={custItemLabel} index={i} />,
                  document.getElementById(`quality-box-${rowKey}`),
                );
                // if (asserts.isExist(qualityLabel)) {
                //   let popoverDiv = document.createElement('div');
                //   popoverDiv.className = 'quality-popover';
                //   childSpan.appendChild(popoverDiv);
                //   let popoverContentDiv = document.createElement('div');
                //   popoverContentDiv.innerHTML = qualityLabel;
                //   popoverContentDiv.className = 'quality-popover-content';
                //   popoverDiv.appendChild(popoverContentDiv);
                //   let popoverArrowDiv = document.createElement('div');
                //   popoverArrowDiv.className = 'popover-arrow';
                //   popoverDiv.appendChild(popoverArrowDiv);
                // }
              }
            }
          }
        }
      }, 0);
    }, [dataSource, qualityVisible]);

    const AppendQualityDom = React.memo(({ custItemLabel, index }) => {
      const { qualityLabel, quality } = custItemLabel;
      return (
        <div className="quality-box-content pointer">
          <div className="quality-box-title">
            {/* <span style={{ width: 40 }}>品质：</span> */}
            {asserts.isExist(qualityLabel) ? (
              <Popover
                placement="bottomLeft"
                visible={index === key && qualityVisible ? true : false}
                // visible={index === 3}
                onVisibleChange={(visible) => getQualityVisible(index, visible)}
                overlayClassName="quality-popover"
                content={
                  <div className="quality-popover-content">
                    {/* <img
                      src={`${process.env.TARGET}static/imgs/quality.png`}
                      alt=""
                      width={300}
                      // height={50}
                    /> */}
                    <div
                      style={{ display: 'inline-block' }}
                      dangerouslySetInnerHTML={{ __html: qualityLabel }}
                    />
                  </div>
                }
              >
                <div>
                  <div
                    // className="qualityTitle"
                    style={{ display: 'inline-block' }}
                    dangerouslySetInnerHTML={{ __html: quality }}
                  />
                  <Icon
                    type={index === key && qualityVisible ? 'up' : 'down'}
                    style={{ fontSize: 12, color: '#000' }}
                  />
                </div>
              </Popover>
            ) : (
              <div>
                <div
                    // className="qualityTitle"
                    style={{ display: 'inline-block' }}
                    dangerouslySetInnerHTML={{ __html: quality }}
                  />
                <Icon
                  type={index === key && qualityVisible ? 'up' : 'down'}
                  style={{ fontSize: 12, color: '#000' }}
                />
              </div>
            )}
          </div>
        </div>
      );
    });

    const getQualityVisible = (index, visible) => {
      dispatch('updateState')({
        key: index,
        qualityVisible: visible,
      });
    };

    // 价格校验
    const getPriceVisible = React.useCallback(
      (record) => {
        if (record.rowKey !== currentKey) return false;
        const { teuncs } = record;
        return isNil(teuncs) || `${teuncs}` === '0';
      },
      [currentKey, dataSource], // eslint-disable-line
    );
    // 起订量校验
    const getMinVisible = React.useCallback(
      (record) => {
        if (record.rowKey !== currentKey) return false;
        const { moqnum, teuncs } = record;
        return !moqnum && !!teuncs;
      },
      [currentKey, dataSource], // eslint-disable-line
    );

    // 特价区起订量校验
    const getSpecialVisible = React.useCallback(
      (record) => {
        if (record.rowKey !== currentKey) return false;
        const { moq, teuncs } = record;
        return !moq && !!teuncs;
      },
      [currentKey, dataSource], // eslint-disable-line
    );

    // 需求量校验
    const getQtyVisible = React.useCallback(
      (record) => {
        if (record.rowKey !== currentKey) return false;
        const { cartItemQty, teuncs } = record;
        const min = isSpecialOffer ? record.moq : record.moqnum;
        return !asserts.isExist(cartItemQty) && !!min && !!teuncs && !isOperation;
      },
      [currentKey, dataSource], // eslint-disable-line
    );

    //库存校验
    const getInventoryVisible = React.useCallback(
      (record) => {
        if (record.rowKey !== currentKey) return false;
        // isNotPack: 加车时不能拆包的情况
        const {
          inventory,
          cartItemQty,
          scStatus,
          isNotPack,
          saleUomInventory,
          upCartItemQty,
        } = record;
        const min = isSpecialOffer ? record.moq : record.moqnum;
        let qty = cartItemQty || upCartItemQty; // 行上的值或者上边框里的值
        // return (inventory < cartItemQty && !scStatus && !!min) || !!isNotPack;
        return (saleUomInventory < qty && !scStatus && !!min) || !!isNotPack;
      },
      [currentKey, dataSource], // eslint-disable-line
    );

    const getActivityVisible = (index, visible) => {
      dispatch('updateState')({
        key: index,
        activityVisible: visible,
      });
    };

    //加车结果
    const getCartTipVisible = React.useCallback(
      (record) => {
        if (record.rowKey !== currentKey) return false;
        const { isSuccess } = record;
        return !!isSuccess;
      },
      [currentKey, dataSource], // eslint-disable-line
    );

    const fetchRemindNumber = async (params) => {
      const { arType } = params;
      const res = await queryRemindNumber(params);
      if (res.success) {
        const result = generatorObject(res.data);
        if (result.success) {
          const { data = 0 } = result;
          arType === '0' ? setNumber(data) : setPrepareNumber(data);
        }
      }
    };

    React.useEffect(() => {
      const dataSource = data.map((item) => ({
        ...item,
        rowKey: isSpecialOffer ? `${item.itm}${item.mmcu}` : `${item.imitm}${item.ibmcu}`,
      }));
      setCurrentKey(undefined);
      setDataSource(dataSource);
    }, [data]); // eslint-disable-line

    // 需求数量
    const onCartQtyVisibleChange = async (index, record, visible) => {
      const { imitm, itemId, ibmcu } = record;
      let unPackFlag = false;
      if (visible) {
        const packRes = await packCheck(imitm, itemId, ibmcu);
        unPackFlag = packRes;
      }
      dispatch('updateState')({
        key: index,
        isOperation: true,
        cartItemQtyVisible: visible,
        currentUnPackFlag: unPackFlag,
        upStockVisible: false,
      });
    };

    const getTitle = (index, record) => {
      const { rowKey, packspec, computedPackage = '', userCart, aaenable } = record;
      let packspecArr = packspec
        ? `1/支 <BR />${packspec}`
            .split('<BR />')
            .filter((item) => asserts.isExist(item))
            .reverse()
        : [];
      let newPackspecArr = packspecArr.map((itm) => {
        let arr = itm.split('/');
        return arr[1].trim();
      });
      if (newPackspecArr.length) {
        return (
          <>
            <Form key={rowKey}>
              {newPackspecArr.map((itm, idx) => {
                return (
                  <Form.Item
                    label=""
                    key={idx}
                    style={{ marginBottom: '0px', fontSize: 12 }}
                    wrapperCol={{ span: 24 }}
                    className="cartQtyFormItem"
                  >
                    {getFieldDecorator(`packSpec${rowKey}${idx}`, {})(
                      // <InputNumber
                      //   style={{ width: 100, display: 'inline-block' }}
                      //   min={0}
                      //   onBlur={(e) => handleBlurCartQtyPop(e, idx, packspecArr, record, index)}
                      //   step={1}
                      // />,
                      <InputNum
                        addonBefore={
                          <Icon
                            className="pointer natural disable-copy"
                            type="minus"
                            onClick={() =>
                              handleChangeWrapper(idx, packspecArr, record, rowKey, 'decrease')
                            }
                          />
                        }
                        addonAfter={
                          <Icon
                            className="pointer natural disable-copy"
                            type="plus"
                            onClick={() =>
                              handleChangeWrapper(idx, packspecArr, record, rowKey, 'add')
                            }
                          />
                        }
                        // value={value}
                        // onBlur={(e) => handleBlurCartQtyPop(e, idx, packspecArr, record, index)}
                        onChange={(e) => handleBlurCartQtyPop(e, idx, packspecArr, record, rowKey)}
                        style={{ width: 140, display: 'inline-block' }}
                        className="popTitle"
                      />,
                    )}
                    <span style={{ marginLeft: '8px' }}>{itm} </span>
                    {itm === '支' && currentUnPackFlag ? (
                      <div className="pack-text">
                        <span className="text-error text1">直接</span>
                        <span className="text-error text2">拆散</span>
                      </div>
                    ) : (
                      <div className="pack-text1"></div>
                    )}
                  </Form.Item>
                );
              })}
            </Form>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
              <p style={{ textAlign: 'center', width: '80%' }}>{`${computedPackage}`}</p>
              {isHavingCust !== 'Y' || `${aaenable}` !== '1' ? null : (
                <>
                  <Tooltip
                    title="购买"
                    overlayClassName="table-desc-tip custom-order-tip"
                    placement="bottom"
                    // visible={true}
                  >
                    <span
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        // record.saleUomFlag === '1' &&
                        // record.isSpecial !== 'Y' &&
                        // !asserts.isExist(record.custInstantRebate || {})
                        //   ? handleSalesUomBuying(record)
                        //   : handleBuying(record);
                        handleBuying(record);
                      }}
                    >
                      <img
                        style={{ width: 17.5, height: 17.5 }}
                        alt="加载中..."
                        src={userCart ? hasShop : noShop}
                      />
                    </span>
                  </Tooltip>
                  <PopUp
                    title={stockTitle}
                    placement="topRight"
                    visible={index === key ? upStockVisible : false}
                    onConfirm={() => handleLinePopStockConfirm(record)}
                    onCancel={handleLinePopStockCancel}
                    onVisibleChange={(visible) => onLinePopStockVisibleChange(index, visible)}
                    okText="加车"
                  >
                    <Tooltip
                      overlayClassName="table-desc-tip custom-order-tip"
                      placement="bottom"
                      title="拆分标识"
                    >
                      <Icon type="caret-down" style={{ color: '#4c9ee4' }} />
                    </Tooltip>
                  </PopUp>
                </>
              )}
            </div>
          </>
        );
      } else {
        return '';
      }
    };

    const handleChangeWrapper = (idx, packspecArr, record, rowKey, type) => {
      let value = form.getFieldValue(`packSpec${rowKey}${idx}`);
      let newValue = 0;
      if (type === 'decrease') {
        if (!value || +value <= 0) {
          form.setFieldsValue({
            [`packSpec${rowKey}${idx}`]: newValue,
          });
        } else {
          newValue = +value - 1;
          form.setFieldsValue({
            [`packSpec${rowKey}${idx}`]: newValue,
          });
        }
      }
      if (type === 'add') {
        newValue = (+value || 0) + 1;
        form.setFieldsValue({
          [`packSpec${rowKey}${idx}`]: newValue,
        });
      }
      handleGetComputedPackSpec(newValue, idx, packspecArr, record, rowKey);
    };

    const handleBlurCartQtyPop = (e, idx, packspecArr, record, rowKey) => {
      handleGetComputedPackSpec(e, idx, packspecArr, record, rowKey);
    };

    const handleGetComputedPackSpec = (qty, idx, packspecArr, record, rowKey) => {
      let values = form.getFieldsValue();
      values[`packSpec${rowKey}${idx}`] = qty;
      let filedKeys = Object.keys(values).filter((key) => key.includes('packSpec'));
      let computedPackage = {};
      let cartItemQtyTotal = 0;
      if (packspecArr.length && filedKeys.length) {
        packspecArr.forEach((item, index) => {
          let itemArr = item.split('/');
          if (
            values[`packSpec${rowKey}${index}`] &&
            asserts.isExist(values[`packSpec${rowKey}${index}`])
          ) {
            computedPackage[index] = values[`packSpec${rowKey}${index}`] + itemArr[1];
            cartItemQtyTotal += maths.mul(values[`packSpec${rowKey}${index}`], itemArr[0]);
          }
        });
      }
      setCurrentKey(undefined);
      const { min } = generateSpecialParams(record);
      const shipment = Math.ceil(cartItemQtyTotal / min) * min || 0;
      const price = record.teuncs || 0;
      const saleUomMoqnum = record.saleUomMoqnum || 0;
      const saleUomPcs = mul(cartItemQtyTotal || 0, saleUomMoqnum);
      // const flag =
      //   record.saleUomFlag !== '1' ||
      //   record.isSpecial === 'Y' ||
      //   asserts.isExist(record.custInstantRebate || {});
      const flag = record.saleUomFlag !== '1';
      setDataSource((preList) =>
        preList.map((item, index) => {
          if (rowKey === item.rowKey) {
            return {
              ...item,
              [`packSpec${rowKey}${idx}`]: values[`packSpec${rowKey}${idx}`],
              upCartItemQty: cartItemQtyTotal,
              unPackFlag: currentUnPackFlag,
              cartItemQty: null,
              computedPackage: asserts.isExist(computedPackage)
                ? Object.values(computedPackage).join('')
                : '',
              pcs: flag
                ? inventoryCal(
                    cartItemQtyTotal,
                    min,
                    record.packspec,
                    record.saleUom,
                    record.saleUomDesc,
                    currentUnPackFlag
                      ? false
                      : cartItemQtyTotal % record.saleUomInventory === 0
                      ? false
                      : true,
                  )
                : `${saleUomPcs}${record.saleUomDesc}`,
              lineAmt: flag ? (price / 1000) * shipment : mul(saleUomPcs, price),
            };
          }
          return item;
        }),
      );
    };
    // 新建收藏夹
    const handleNew = () => {
      dispatch('updateState')({ isNew: true });
    };

    // 收藏
    const onCollectVisibleChange = (index, visible) => {
      dispatch('updateState')({
        key: index,
        isOperation: true,
        collectVisible: visible,
      });
    };
    // 确认收藏
    const handleCollectConfirm = (record) => {
      const val = isNew ? getFieldValue('uitemCode') : collection;
      if (!asserts.isExist(val)) {
        message.warning('请选择或新建收藏夹', () =>
          dispatch('updateState')({ isNew: false, collection: '默认收藏夹' }),
        );
        return;
      }
      handleCollect(record, val, isNew);
      dispatch('updateState')({ isNew: false, collection: '默认收藏夹' });
      resetFields();
    };

    const handleCollectCancel = () => {
      dispatch('updateState')({
        key: null,
        collectVisible: false,
        isNew: false,
        collection: '默认收藏夹',
      });
      resetFields();
    };

    const resetCustomCodeFormState = () => {
      dispatch('updateState')({
        customCodeAddOrEdit: false,
        editingCustomCodeItem: null,
      });
    };

    const getCustomImitm = (row) => (isSpecialOffer ? row.itm : row.imitm);

    const fetchCustomCodeList = (record) => {
      resetCustomCodePopGuards();
      const imitm = getCustomImitm(record);
      const preferUitemCode = record.userCode || null;
      dispatch('updateState')({
        customQueryImitm: imitm,
        newCustomCodeList: [],
        newCustomCode: preferUitemCode,
        customCodeListLoading: true,
        customCodeAddOrEdit: false,
        editingCustomCodeItem: null,
      });
      dispatch('queryCustom')({ imitm, preferUitemCode });
    };

    const onCustomVisibleChange = (record, index, visible) => {
      const shouldKeepOpen =
        suppressCustomPopCloseRef.current || customCodeAddOrEditRef.current;

      if (!visible && shouldKeepOpen) {
        if (index === key) {
          const patch = {
            customCode: record.customCode,
            key: index,
            isOperation: true,
            customVisible: true,
          };
          if (customCodeAddOrEditRef.current) {
            patch.customCodeAddOrEdit = true;
          }
          dispatch('updateState')(patch);
        }
        return;
      }
      if (visible) {
        dispatch('updateState')({
          customCode: record.customCode,
          key: index,
          isOperation: true,
          customVisible: true,
        });
        fetchCustomCodeList(record);
        return;
      }
      window.setTimeout(() => {
        if (customCodeAddOrEditRef.current || suppressCustomPopCloseRef.current) {
          return;
        }
        resetCustomCodeFormState();
        resetCustomCodePopGuards();
        dispatch('updateState')({
          customCode: record.customCode,
          key: index,
          isOperation: true,
          customVisible: false,
          newCustomCodeList: [],
          newCustomCode: null,
          customCodeListLoading: false,
        });
      }, 0);
    };

    const refreshCustomCodeList = (row) => {
      const imitm = customQueryImitm || getCustomImitm(row);
      const preferUitemCode = newCustomCode || row.userCode || null;
      if (isExist(imitm)) {
        dispatch('queryCustom')({ imitm, preferUitemCode });
      }
    };

    // 确认自定义（用 ref 判断编辑态，避免 Popconfirm 关闭先于 onConfirm 清掉 state）
    const handleCustomConfirm = async (record) => {
      const inEditMode = customCodeAddOrEditRef.current;
      const editingItem = editingCustomCodeItemRef.current;

      if (inEditMode) {
        const uitemCode = getFieldValue('customCode');
        if (!isExist(uitemCode) || !trim(uitemCode)) {
          message.warning('请输入自定义编码');
          return;
        }
        const trimmedCode = trim(uitemCode);
        const oldUitemCode =
          editingItem && isExist(editingItem.uitemCode) ? editingItem.uitemCode : '';
        handleCustom(record, trimmedCode, oldUitemCode);
        refreshCustomCodeList(record);
      } else {
        if (!isExist(newCustomCode)) {
          message.warning('请选择自定义编码');
          return;
        }
        const oldUitemCode = isExist(record.userCode) ? record.userCode : '';
        handleCustom(record, newCustomCode, oldUitemCode);
      }
      dispatch('updateState')({
        customVisible: false,
        customCode: '',
        newCustomCodeList: [],
        newCustomCode: null,
        customCodeListLoading: false,
      });
      resetCustomCodeFormState();
      resetCustomCodePopGuards();
      resetFields();
    };

    const handleCustomCancel = () => {
      resetCustomCodePopGuards();
      dispatch('updateState')({
        key: null,
        customVisible: false,
        customCode: '',
        newCustomCodeList: [],
        newCustomCode: null,
        customCodeListLoading: false,
      });
      resetCustomCodeFormState();
      resetFields();
    };
    // 图纸
    const handleDrafting = (record) => {
      dispatch('updateState')({
        record,
        modalVisible: true,
      });
    };

    //图片
    const handleImgsClick = (record) => {
      dispatch('updateState')({ record, imgsModalVisible: true });
      dispatch('queryListImgs')({
        record,
        searchValue: asserts.isExist(searchValue)
          ? searchValue
          : { ibsrp7: [], CAT_32: [], CAT_35: [], CAT_37: [] },
      });
    };

    const handleCancel = () => dispatch('updateState')({ modalVisible: false, record: {} });
    const handleImgsModalCancel = () => {
      dispatch('updateState')({ imgsModalVisible: false, imgs: [], record: {} });
    };
    // table Change
    const handleChange = (pagination, filters, sorter) => {
      const { pageSize } = pagination;
      setPageSize(pageSize);
      setCurrentKey(undefined);
      onTableChange(pagination, filters, sorter);
    };

    // 特价区和搜索表某些字段不同，获取同一个字段
    const generateSpecialParams = (record) => {
      const moqString = isSpecialOffer ? record.moq2 : record.moq; //起订量字符串
      const warehouse = isSpecialOffer ? record.mmcu : record.ibmcu; //仓别
      const min = isSpecialOffer ? record.moq : record.moqnum; // todo起订量
      const projectNo = isSpecialOffer ? record.itm : record.imitm; //短项目号
      return { moqString, warehouse, min, projectNo };
    };

    const filterData = React.useMemo(() => {
      const source = dataSource.filter((item) => {
        const { iconScopeMoqnum, iconScope, inventory, scStatus, saleUomInventory } = item;
        const { min } = generateSpecialParams(item);
        const showIconMinNumber = !!iconScope ? iconScope : iconScopeMoqnum * min;
        const showIcon = showIconMinNumber >= saleUomInventory;
        return showIcon && scStatus;
      });
      return source;
    }, [dataSource]); // eslint-disable-line

    const getComputedPackSpec = (record, value, index) => {
      const { packspec } = record;
      let packspecArr = packspec
        ? packspec.split('<BR />').filter((item) => asserts.isExist(item))
        : [];
      let params = {};
      packspecArr.reverse().forEach((item, idx) => {
        params[`packSpec${index}${idx}`] = '';
      });
      form.setFieldsValue(params);
      let unitList = [
        {
          unitKey: 1,
          name: '支',
          rate: 1,
        },
      ];
      packspecArr.forEach((item, index) => {
        let arr = item.split('/');
        unitList.push({
          unitKey: index + 2,
          name: arr[1],
          rate: arr[0],
        });
      });
      const unitFormat = (count, unitKey) => {
        const baseUnitRate = unitList.find((u) => u.unitKey === unitKey); // 找出单位
        if (!baseUnitRate) return [];
        // 把单位转为基本单位
        let countRate = count * baseUnitRate.rate;
        for (var i = unitList.length - 1; i >= 0; i--) {
          const { rate } = unitList[i];
          unitList[i].formatVal = Math.floor(countRate / rate); // 给list中添加了format中添加了字段
          countRate = countRate % rate; // 存储余数
          // 如果余数为0，则直接跳出
          if (countRate === 0) break;
        }
        return unitList;
      };
      let formatStr = '';
      if (value) {
        const formatValue = unitFormat(value, 1).filter(
          (item) => Object.keys(item).includes('formatVal') && item.formatVal !== 0,
        );
        formatStr = formatValue.reverse().reduce((res, cur) => {
          res += `${cur.formatVal || 0}${cur.name}`;
          return res;
        }, '');
      }

      return formatStr;
    };

    const clearPackSpecParams = (record, lineIndex) => {
      const { rowKey, packspec } = record;
      let packspecArr = packspec
        ? `0/支 <BR />${packspec}`
            .split('<BR />')
            .filter((item) => asserts.isExist(item))
            .reverse()
        : [];
      let params = {};
      packspecArr.forEach((item, index) => {
        params[`packSpec${rowKey}${index}`] = null;
      });
      form.setFieldsValue({ ...params });
      return params;
    };

    // 需求量变化
    const handleQuanChange = (record, value, index) => {
      setCurrentKey(undefined);
      const { min } = generateSpecialParams(record);
      const shipment = Math.ceil(value / min) * min || 0;
      const price = record.teuncs || 0;
      const saleUomMoqnum = record.saleUomMoqnum || 0;
      const saleUomPcs = mul(value || 0, saleUomMoqnum);
      // const flag =
      //   record.saleUomFlag !== '1' ||
      //   record.isSpecial === 'Y' ||
      //   asserts.isExist(record.custInstantRebate || {});
      const flag = record.saleUomFlag !== '1';
      setDataSource((preList) =>
        preList.map((pre) => {
          if (pre.rowKey === record.rowKey) {
            let packSpecParams = clearPackSpecParams(record, index);
            return {
              ...pre,
              ...packSpecParams,
              upCartItemQty: null,
              unPackFlag: currentUnPackFlag,
              cartItemQty: value,
              computedPackage: '',
              // computedPackage:
              //   !isSpecialOffer && !isIndustryZone ? getComputedPackSpec(record, value, index) : '',
              pcs: flag
                ? inventoryCal(
                    value,
                    min,
                    record.packspec,
                    record.saleUom,
                    record.saleUomDesc,
                    !currentUnPackFlag && value % record.saleUomInventory === 0 ? false : true,
                  )
                : `${saleUomPcs}${record.saleUomDesc}`,
              lineAmt: flag ? (price / 1000) * shipment : mul(saleUomPcs, price),
            };
          }

          return pre;
        }),
      );
    };

    const handleBlur = async (record) => {
      // const flag =
      //   record.saleUomFlag !== '1' ||
      //   record.isSpecial === 'Y' ||
      //   asserts.isExist(record.custInstantRebate || {});
      const flag = record.saleUomFlag !== '1';
      if (!record.cartItemQty) return;

      const { imitm, itemId, ibmcu } = record;
      const warehouse = isSpecialOffer ? record.mmcu : record.ibmcu; //仓别
      const projectNo = isSpecialOffer ? record.itm : record.imitm; //短项目号
      await packCheck(projectNo, itemId, warehouse).then((packRes) => {
        setDataSource((preList) =>
          preList.map((item) => {
            if (item.rowKey === record.rowKey) {
              const {
                scMoq,
                scMoqnum,
                scStatus,
                cartItemQty,
                packspec,
                inventory,
                saleUomInventory,
              } = record;
              const { min } = generateSpecialParams(record);
              // const isShortageMin = !!scMoq || !!scMoqnum;
              const shortageMin = !!scMoq ? scMoq : scMoqnum * min;
              const value =
                !!scStatus && cartItemQty < shortageMin && cartItemQty > saleUomInventory
                  ? shortageMin
                  : cartItemQty;
              return {
                ...item,
                unPackFlag: packRes,
                pcs: flag
                  ? inventoryCal(
                      value,
                      isSpecialOffer ? record.moq : record.moqnum,
                      packspec,
                      record.saleUom,
                      record.saleUomDesc,
                      !packRes && value % saleUomInventory === 0 ? false : true,
                    )
                  : `${mul(value || 0, record.saleUomMoqnum)}${record.saleUomDesc}`,
              };
            }
            return item;
          }),
        );
      });
    };

    // 加车结果处理
    const handleAddCartResult = (addRes = {}, itemKey) => {
      if (addRes.success) {
        const result = generatorObject(addRes.data);
        if (!result.success) {
          message.error(result.message);
          return;
        }
        const { addCartFlag, addCarFlagDesc } = result.data;
        setDataSource((preList) =>
          preList.map((pre) => {
            if (pre.rowKey === itemKey)
              return {
                ...pre,
                isSuccess: true,
                userCart: !!addCartFlag,
                addCarFlagDesc: addCarFlagDesc,
              };
            return pre;
          }),
        );
        dispatch('updateState')({ stockCodeList: [] });
        setTimeout(() => {
          setDataSource((preList) =>
            preList.map((pre) => {
              if (pre.rowKey === itemKey)
                return {
                  ...pre,
                  isSuccess: false,
                  addCarFlagDesc: null,
                };
              return pre;
            }),
          );

          setCurrentKey(undefined);
        }, 3000);
        eventBus.emit(eventBus.type.UPDATE_CART_COUNT);
      }
    };

    const getCartPackSpecParams = (record) => {
      const { packspec, rowKey } = record;
      let packspecArr = packspec
        ? `0/支 <BR />${packspec}`
            .split('<BR />')
            .filter((item) => asserts.isExist(item))
            .reverse()
        : [];
      let fieldObj = { 箱: 'bx', 盒: 'box', 袋: 'sb', 支: 'pc' };
      let cartPack = {};
      packspecArr.forEach((item, index) => {
        let itemArr = item.split('/');
        if (
          Object.keys(record).includes(`packSpec${rowKey}${index}`) &&
          record[`packSpec${rowKey}${index}`]
        ) {
          let unit = fieldObj[`${itemArr[1]}`.trim()];
          cartPack[unit] = record[`packSpec${rowKey}${index}`];
        }
      });
      return cartPack;
    };

    //正常加车
    const handleAddCartRequest = async (record) => {
      const {
        itemId,
        inventory,
        cartItemQty, // 填写的需求数量
        scAttribute,
        scOrderMoq,
        scOrderMoqnum,
        scMoq,
        scMoqnum,
        scDay,
        scRemark,
        scDelivery,
        scMargin,
        scDeliveryDay,
        rowKey,
        saleUomInventory,
        packspec,
        isUpToCart,
      } = record;
      let cartPack = isUpToCart ? getCartPackSpecParams(record) : {};
      const { warehouse, min, projectNo } = generateSpecialParams(record);
      const isSpecialPack = getSpecialShouldCheck(saleUomInventory, min, cartItemQty);
      const isPack = getStockoutShoulePack(saleUomInventory, min, cartItemQty);
      const isSearchPack = getSearchPageShouldPack(cartItemQty, packspec, min);
      // isSpecialPack || isPack || isSearchPack  其中有一个为true 代表需要拆散
      if (isSpecialPack || isPack || isSearchPack) {
        const packRes = await packCheck(projectNo, itemId, warehouse);
        let pcs = cartItemQty; //需要拆散时出货数量是实际需求量
        // 此商品不支持拆散出货
        if (isUpToCart) {
          if (!packRes) {
            message.error('此商品不支持拆散出货');
            if (cartItemQty % saleUomInventory !== 0) {
              const maxMul = Math.ceil(cartItemQty / min);
              pcs = maxMul * min;
            }
          }
        } else {
          // 从下面的框输入不管支不支持拆散，都以整数倍加车
          if (!packRes && cartItemQty % saleUomInventory === 0) {
            pcs = cartItemQty;
          } else {
            const maxMul = Math.ceil(cartItemQty / min);
            pcs = maxMul * min;
          }
        }
        const res = await saveToCart(
          projectNo,
          itemId,
          warehouse,
          min,
          cartItemQty,
          pcs,
          scAttribute,
          scOrderMoq,
          scOrderMoqnum,
          scMoq,
          scMoqnum,
          scDay,
          scRemark,
          scDelivery,
          scMargin,
          scDeliveryDay,
          isUpToCart ? packRes : false,
          CALLSOURCE,
          stockCodeList,
          cartPack,
        );
        handleAddCartResult(res, rowKey, packRes);
      } else {
        //正常情况不需要拆散时加车
        const maxMul = Math.ceil(cartItemQty / min);
        const pcs = maxMul * min;
        const res = await saveToCart(
          projectNo,
          itemId,
          warehouse,
          min,
          cartItemQty,
          pcs,
          scAttribute,
          scOrderMoq,
          scOrderMoqnum,
          scMoq,
          scMoqnum,
          scDay,
          scRemark,
          scDelivery,
          scMargin,
          scDeliveryDay,
          false,
          CALLSOURCE,
          stockCodeList,
          cartPack,
        );
        handleAddCartResult(res, rowKey, false);
      }
    };
    //缺货加车
    const handleShortageAdd = async (record) => {
      const {
        itemId,
        scMoq,
        scMoqnum,
        cartItemQty,
        scAttribute,
        scOrderMoq,
        scOrderMoqnum,
        scDay,
        scRemark,
        scDelivery,
        scMargin,
        scDeliveryDay,
        rowKey,
        isUpToCart,
      } = record;
      let cartPack = isUpToCart ? getCartPackSpecParams(record) : {};
      const { warehouse, min, projectNo } = generateSpecialParams(record);
      // 配置了缺货时，比较需求量和缺货起订量(缺货起订量存在并且大于需求量，出货量按照缺货数量计算， 如果缺货数量不是倍数，取最近的倍数)
      const isShortageMin = !!scMoq || !!scMoqnum;
      const shortageMin = !!scMoq ? scMoq : scMoqnum * min;
      let pcs;
      if (isShortageMin && shortageMin > cartItemQty) {
        if (shortageMin % min !== 0) {
          const minMultiple = Math.ceil(shortageMin / min); // 基于缺货起订量，最小起订量向上取整的倍数
          pcs = minMultiple * min;
        } else {
          pcs = shortageMin; //否则直接用缺货起订量
        }
      } else {
        const maxMul = Math.ceil(cartItemQty / min); //需求数量大于缺货起订量时，直接按照商品起订量计算
        pcs = maxMul * min;
      }
      const shortageAddRes = await saveToCart(
        projectNo, //短项目号
        itemId,
        warehouse,
        min,
        cartItemQty,
        pcs,
        scAttribute,
        scOrderMoq,
        scOrderMoqnum,
        scMoq,
        scMoqnum,
        scDay,
        scRemark,
        scDelivery,
        scMargin,
        scDeliveryDay,
        false,
        CALLSOURCE,
        stockCodeList,
        cartPack,
      );

      handleAddCartResult(shortageAddRes, rowKey, false);
    };
    //自定义单价加车 (废弃)
    const handleSalesUomAdd = async (record) => {
      const {
        imitm,
        itemId,
        ibmcu,
        cartItemQty,
        saleUom,
        saleUomMoqnum,
        scAttribute,
        scOrderMoq,
        scOrderMoqnum,
        scMoq,
        scMoqnum,
        scDay,
        scRemark,
        scDelivery,
        scMargin,
        scDeliveryDay,
        rowKey,
      } = record;
      const pcs = mul(cartItemQty, saleUomMoqnum);
      const res = await saveSalesUomToCart(
        imitm,
        itemId,
        ibmcu,
        saleUom,
        saleUomMoqnum,
        cartItemQty,
        pcs,
        scAttribute,
        scOrderMoq,
        scOrderMoqnum,
        scMoq,
        scMoqnum,
        scDay,
        scRemark,
        scDelivery,
        scMargin,
        scDeliveryDay,
        false,
        CALLSOURCE,
        stockCodeList,
      );
      handleAddCartResult(res, rowKey, false);
    };

    // 加入购物车
    //✳ 只有普通商品加车可以拆散，缺货没有拆散逻辑！！！
    const handleBuying = (record) => {
      setCurrentKey(record.rowKey);
      const {
        inventory,
        scStatus,
        userCart,
        teuncs,
        scMargin,
        saleUomInventory,
        upCartItemQty,
      } = record;
      // isUpToCart 代表是否是从上边的各种包装框里加车的
      let isUpToCart =
        keys(record).some((key) => key.includes(`packSpec${record.rowKey}`)) &&
        asserts.isExist(upCartItemQty);
      let cartItemQty = isUpToCart ? upCartItemQty : record.cartItemQty;
      const visible = getQtyVisible({ ...record, cartItemQty });
      if (visible) {
        message.warn('请输入数量');
        return;
      }
      if (isUpToCart) {
        dispatch('updateState')({
          cartItemQtyVisible: false,
        });
      }
      const { min } = generateSpecialParams(record);
      const isValidate = !cartItemQty || !teuncs || !min;
      if (isValidate) return;
      // 库存不足时 && 配置了缺货下单 cartItemQty > inventory&& scStatus  2022.03.25 修改为 cartItemQty > saleUomInventory
      if (cartItemQty > saleUomInventory && scStatus) {
        // //如果未配置缺货下单
        // if (!scStatus) return;
        //配置余量时提示误差
        if (!!scMargin) {
          const scMarginContent = `由于您选择的属非“常备库存”产品，需要工厂定制生产，最终交付支数为下单支数的${scMargin}波动范围。若能接受，可点击“确定”下单!`;
          confirm({
            title: '提示',
            content: scMarginContent,
            okText: '确定',
            okType: 'btn-info',
            okButtonProps: { type: 'primary', className: 'btn-info' },
            cancelText: '取消',
            async onOk() {
              handleShortageAdd({ ...record, cartItemQty, isUpToCart });
            },
          });
        } else {
          handleShortageAdd({ ...record, cartItemQty, isUpToCart }); //缺货加车
        }
        return;
      }

      // 判断是不是再次加车
      if (userCart) {
        confirm({
          title: '提示',
          content: '购物车已存在该商品，是否继续添加？',
          okText: '确定',
          okType: 'btn-info',
          okButtonProps: { type: 'primary', className: 'btn-info' },
          cancelText: '取消',
          async onOk() {
            handleAddCartRequest({ ...record, cartItemQty, isUpToCart });
          },
        });
      } else {
        handleAddCartRequest({ ...record, cartItemQty, isUpToCart });
      }
    };

    //自定义单价商品加车
    const handleSalesUomBuying = (record) => {
      setCurrentKey(record.rowKey);
      const { saleUomInventory, cartItemQty, userCart, teuncs, saleUomMoqnum } = record;
      const isValidate = !cartItemQty || !teuncs || !saleUomMoqnum;
      if (isValidate) return;
      // 库存不足时
      if (mul(cartItemQty, saleUomMoqnum) > saleUomInventory) return;
      else {
        // 判断是不是再次加车
        if (userCart) {
          confirm({
            title: '提示',
            content: '购物车已存在该商品，是否继续添加？',
            okText: '确定',
            okType: 'btn-info',
            okButtonProps: { type: 'primary', className: 'btn-info' },
            cancelText: '取消',
            async onOk() {
              handleSalesUomAdd(record);
            },
          });
        } else {
          handleSalesUomAdd(record);
        }
      }
    };

    //展示有货提醒弹框
    const handleShowRemind = (record, type) => {
      const { itm, imitm, mmcu, ibmcu } = record;
      const selectedItem = {
        arImitm: isSpecialOffer ? itm : imitm,
        arMcu: isSpecialOffer ? mmcu : ibmcu,
      };
      const params = {
        ...selectedItem,
        arType: type,
      };
      type === '0' ? setRemindVisible(true) : setPrepareVisible(true);
      fetchRemindNumber(params);
      setSelectedItem(selectedItem);
    };

    const handleHideRemind = () => {
      setNumber(0);
      setRemindVisible(false);
    };

    const handleHidePrepare = () => {
      setPrepareNumber(0);
      setPrepareVisible(false);
    };

    // 收藏弹框内容
    const collectTitle = (
      <Form className="tm-search-form-layout" {...formItemLayout}>
        {!isNew ? (
          <Form.Item label="收藏夹">
            <div
              onMouseDown={(e) => {
                e.preventDefault();
                return false;
              }}
            >
              <Selection
                source={favorite}
                style={{ width: 200 }}
                value={collection}
                onChange={(val) => dispatch('updateState')({ collection: val })}
                dropdownRender={(menu) => (
                  <div>
                    {menu}
                    <div className="pointer text-red newFavorite" onClick={handleNew}>
                      新建收藏夹
                    </div>
                  </div>
                )}
              />
            </div>
          </Form.Item>
        ) : (
          <Form.Item label="收藏夹">{getFieldDecorator('uitemCode', {})(<Input />)}</Form.Item>
        )}
      </Form>
    );

    // 新增自定义编码
    const handleNewCustomCode = () => {
      resetFields(['customCode']);
      suppressCustomPopCloseRef.current = true;
      customCodeAddOrEditRef.current = true;
      editingCustomCodeItemRef.current = null;
      dispatch('updateState')({
        customCodeAddOrEdit: true,
        editingCustomCodeItem: null,
        customVisible: true,
      });
    };

    const stopSelectEvent = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };

    const handleEditCustomCodeItem = (item, e) => {
      stopSelectEvent(e);
      suppressCustomPopCloseRef.current = true;
      customCodeAddOrEditRef.current = true;
      editingCustomCodeItemRef.current = item;
      dispatch('updateState')({
        customCodeAddOrEdit: true,
        editingCustomCodeItem: item,
        customVisible: true,
      });
      requestAnimationFrame(() => {
        setFields({ customCode: { value: item.uitemCode } });
        dispatch('updateState')({ customVisible: true, customCodeAddOrEdit: true });
      });
    };

    const keepCustomPopOpen = () => {
      if (customCodeAddOrEditRef.current) {
        dispatch('updateState')({ customVisible: true });
      }
    };

    const handleDeleteCustomCodeItem = (item, e) => {
      stopSelectEvent(e);
      const uitemId = item.uitemId;
      if (!isExist(uitemId)) {
        message.warning('无法删除该编码');
        return;
      }
      const imitm = customQueryImitm;
      const preferUitemCode = newCustomCode;

      resetCustomCodeFormState();
      resetCustomCodePopGuards();
      dispatch('updateState')({ customVisible: false });

      showCustomCodeDeleteConfirm({ uitemId, imitm, preferUitemCode, dispatch });
    };

    const customCodeTransfer = { key: 'uitemId', code: 'uitemCode', name: 'uitemCode' };

    const renderCustomCodeOption = (Option, data) => {
      const value = data.uitemCode;
      return (
        <Option
          key={data.uitemId || value}
          value={value}
          label={value}
          className="custom-code-option"
        >
          <span className="custom-code-option__label">{value}</span>
          <span className="custom-code-option__actions">
            <Icon
              type="edit"
              title="编辑"
              onMouseDown={(e) => handleEditCustomCodeItem(data, e)}
            />
            <Icon
              type="delete"
              title="删除"
              onMouseDown={(e) => handleDeleteCustomCodeItem(data, e)}
            />
          </span>
        </Option>
      );
    };

    // 自定义编码弹框内容
    const customTitle = (
      // <Form className="customTitle">
      //   <Form.Item label="自定义编码" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
      //     {getFieldDecorator('customCode', { initialValue: customCode })(<Input />)}
      //   </Form.Item>
      // </Form>
      <Form
        className="customTitle custom-code-pop-form"
        onMouseDown={customCodeAddOrEdit ? stopSelectEvent : undefined}
        onClick={customCodeAddOrEdit ? stopSelectEvent : undefined}
      >
        {!customCodeAddOrEdit ? (
          <Form.Item label="自定义编码">
            <div
              onMouseDown={(e) => {
                e.preventDefault();
                return false;
              }}
            >
              <Selection
                source={newCustomCodeList}
                transfer={customCodeTransfer}
                style={{ width: 200 }}
                value={newCustomCode}
                loading={customCodeListLoading}
                getPopupContainer={getCustomCodeSelectPopupContainer}
                optionLabelProp="label"
                dropdownClassName="custom-code-select-dropdown"
                optionRender={renderCustomCodeOption}
                onChange={(val) => dispatch('updateState')({ newCustomCode: val })}
                dropdownRender={(menu) => (
                  <div>
                    {menu}
                    <div className="pointer text-red newFavorite" onClick={handleNewCustomCode}>
                      新增自定义编码
                    </div>
                  </div>
                )}
              />
            </div>
          </Form.Item>
        ) : (
          <Form.Item
            label="自定义编码"
            key={editingCustomCodeItem ? `edit-${editingCustomCodeItem.uitemId}` : 'new-custom-code'}
          >
            <div onMouseDown={stopSelectEvent}>
              {getFieldDecorator('customCode', {
                initialValue: editingCustomCodeItem ? editingCustomCodeItem.uitemCode : undefined,
              })(
                <Input
                  autoFocus
                  onFocus={keepCustomPopOpen}
                  onMouseDown={stopSelectEvent}
                  onClick={stopSelectEvent}
                />,
              )}
            </div>
          </Form.Item>
        )}
      </Form>
    );

    const RenderFooter = () => (
      <div className="align-right">
        <Link to="/cart">
          <Button className="btn-info">去购物车</Button>
        </Link>
      </div>
    );

    // 行上的新建拆分标识
    const handleLineNewStock = () => {
      dispatch('queryStockCode')();
    };

    // 拆分标识
    const onLineStockVisibleChange = (index, visible) => {
      dispatch('updateState')({
        key: index,
        stockVisible: visible,
      });
    };

    const handleLineStockCancel = () => {
      dispatch('updateState')({
        key: null,
        stockVisible: false,
        isNew: false,
        stockCode: null,
        stockCodeList: [],
      });
      resetFields();
    };
    // 确认拆分标识
    const handleLineStockConfirm = (record, type) => {
      const val = isNew ? getFieldValue('stockCode') : stockCodeList;
      if (!asserts.isExist(val)) {
        message.warning('请选择或新建拆分标识', () =>
          dispatch('updateState')({ isNew: false, stockCode: null, stockCodeList: [] }),
        );
        return;
      }
      if (isNew) {
        let params = {
          ssCode: stockCode,
          ssName: val,
          ssId: maths.genFakeId(-1),
        };
        dispatch('saveStock')(params).then((result) => {
          if (result) {
            dispatch('updateState')({ isNew: false, stockCode: null });
            handleStock(isNew);
          }
        });
      }
      handleBuying(record);
      dispatch('updateState')({ isNew: false, stockVisible: false });
      resetFields();
    };

    // 拆分标识弹框内容
    const stockTitle = (
      <Form {...formItemLayout}>
        {!isNew ? (
          <Form.Item label="拆分标识">
            <div
              onMouseDown={(e) => {
                e.preventDefault();
                return false;
              }}
            >
              <Selection
                source={stockList}
                style={{ width: 200 }}
                value={stockCodeList}
                onChange={(val) => dispatch('updateState')({ stockCodeList: [val] })}
                transfer={{ key: 'ssId', name: 'ssName', code: 'ssCode' }}
                placeholder="请选择拆分标识"
                dropdownRender={(menu) => (
                  <div>
                    {menu}
                    <div className="pointer text-red newFavorite" onClick={handleLineNewStock}>
                      新建拆分标识
                    </div>
                  </div>
                )}
                // mode="multiple"
              />
            </div>
          </Form.Item>
        ) : (
          <Form.Item label="拆分标识">{getFieldDecorator('stockCode', {})(<Input />)}</Form.Item>
        )}
      </Form>
    );

    // 拆分标识
    const onLinePopStockVisibleChange = (index, visible) => {
      dispatch('updateState')({
        key: index,
        upStockVisible: visible,
      });
    };

    const handleLinePopStockCancel = () => {
      dispatch('updateState')({
        // key: null,   // todo
        upStockVisible: false,
        isNew: false,
        stockCode: null,
        stockCodeList: [],
      });
      resetFields();
    };
    // 确认拆分标识
    const handleLinePopStockConfirm = (record, type) => {
      const val = isNew ? getFieldValue('stockCode') : stockCodeList;
      if (!asserts.isExist(val)) {
        message.warning('请选择或新建拆分标识', () =>
          dispatch('updateState')({ isNew: false, stockCode: null, stockCodeList: [] }),
        );
        return;
      }
      if (isNew) {
        let params = {
          ssCode: stockCode,
          ssName: val,
          ssId: maths.genFakeId(-1),
        };
        dispatch('saveStock')(params).then((result) => {
          if (result) {
            dispatch('updateState')({ isNew: false, stockCode: null });
            handleStock(isNew);
          }
        });
      }
      handleBuying(record);
      dispatch('updateState')({ isNew: false, upStockVisible: false });
      resetFields();
    };

    // 获取活动展示内容
    const getActivityList = (record) => {
      const {
        activityList,
        custInstantRebateNew,
        teuncs = 0,
        originalAmt = 0,
        weight = 0,
        packbx = '',
        levelAmt = 0,
      } = record;
      let newInstantRebatetList = [];
      // 是否展示其他活动
      let isOnly =
        Array.isArray(custInstantRebateNew) &&
        custInstantRebateNew.length &&
        custInstantRebateNew[0].disType === '3';
      if (Array.isArray(custInstantRebateNew) && custInstantRebateNew.length) {
        // eslint-disable-next-line prefer-destructuring
        let {
          actType,
          disType,
          disStrategy, // 1-折上折，2-当前折扣
          custTieredRebateList,
          disMeasure,
          moqMeasure,
        } = custInstantRebateNew[0];
        if (Array.isArray(custTieredRebateList) && custTieredRebateList.length) {
          newInstantRebatetList = custTieredRebateList
            .sort((a, b) => a.tieredMeasure - b.tieredMeasure)
            .map((item) => {
              const data = calculateActivityPrice(
                actType,
                disType,
                moqMeasure,
                item,
                disStrategy,
                levelAmt,
                teuncs,
                originalAmt,
                weight,
                packbx,
              );
              return {
                ...item,
                ...data,
              };
            });
        } else {
          const data = calculateActivityPrice(
            actType,
            disType,
            moqMeasure,
            { disMeasure, tieredMeasure: moqMeasure },
            disStrategy,
            levelAmt,
            teuncs,
            originalAmt,
            weight,
            packbx,
          );
          newInstantRebatetList.push(data);
        }
      }
      let filterActivity = activityList
        .filter((item) => !item.deleteFlag && asserts.isExist(item.discount) && item.discount >= 1)
        .map((itm) => {
          return {
            ...itm,
            discount: maths.mul(maths.sub(itm.discount, 1), 100).toFixed(2),
            activityName:
              itm.activity === 'MCU'
                ? '仓库优惠'
                : itm.activity === 'DIS'
                ? '商品折扣'
                : itm.activity === 'FIXED'
                ? '商品折扣一口价'
                : itm.activity === 'SPECIAL'
                ? '特价'
                : null,
            activityFlag: 0,
          };
        });
      let newList = isOnly
        ? [
            {
              activityName: '满减活动',
              activityFlag: 1,
              dataSource: clone(newInstantRebatetList),
            },
          ]
        : newInstantRebatetList.length
        ? concat(
            [
              {
                activityName: '满减活动',
                activityFlag: 1,
                dataSource: clone(newInstantRebatetList),
              },
            ],
            filterActivity,
          )
        : filterActivity;
      return newList;
    };

    const calculateActivityPrice = (
      actType,
      disType,
      moqMeasure,
      item,
      disStrategy,
      levelAmt,
      teuncs,
      originalAmt,
      weight,
      packbx,
    ) => {
      const { tieredMeasure, disMeasure } = item;
      let lastPrice = 0;
      let discountPoint = 0;
      let price = disStrategy === '1' ? formatPrice(teuncs) : formatPrice(levelAmt); // 满减当前折扣价格按级别价(levelAmt)算
      if (disType === '1') {
        // 减金额 满金额
        if (actType === '1') {
          let qty = maths.div(tieredMeasure || 0, price || 0);
          lastPrice = maths
            .div(maths.sub(tieredMeasure || 0, disMeasure || 0), qty || 0)
            .toFixed(2);
        }
        // 减金额 满重量
        if (actType === '2') {
          let qty = maths.div(tieredMeasure || 0, weight || 0);
          // let qty = maths.div(maths.mul(tieredMeasure || 0, 1000), weight || 0);
          let originalAmt = maths.mul(maths.div(price || 0, 1000), qty || 0);
          lastPrice = maths
            .mul(maths.div(maths.sub(originalAmt || 0, disMeasure || 0), qty), 1000)
            .toFixed(2);
        }
        // 减金额 满箱数
        if (actType === '3') {
          let box = packbx.substring(0, packbx.indexOf('/'));
          let qty = maths.mul(tieredMeasure || 0, Number(box));
          let originalAmt = maths.mul(maths.div(price || 0, 1000), qty || 0);
          lastPrice = maths
            .mul(maths.div(maths.sub(originalAmt || 0, disMeasure || 0), qty), 1000)
            .toFixed(2);
        }
        // 减金额 满支数
        if (actType === '4') {
          let qty = tieredMeasure;
          let originalAmt = maths.mul(maths.div(price || 0, 1000), qty || 0);
          lastPrice = maths
            .mul(maths.div(maths.sub(originalAmt || 0, disMeasure || 0), qty), 1000)
            .toFixed(2);
        }
        discountPoint = '-' + disMeasure + '元';
      } else if (disType === '2') {
        // 减折扣
        lastPrice = maths.div(price || 0, disMeasure || 0).toFixed(2);
        discountPoint = '-' + maths.mul(maths.sub(disMeasure || 0, 1), 100) + '%';
      } else if (disType === '3') {
        lastPrice = disMeasure;
        let pointPrice =
          disStrategy === '1'
            ? formatPrice(teuncs)
            : asserts.isExist(originalAmt)
            ? formatPrice(originalAmt)
            : formatPrice(levelAmt); // 浮动按涨价后的(originalAmt)算
        discountPoint =
          '-' +
          maths.mul(maths.sub(maths.div(pointPrice || 0, disMeasure), 1), 100).toFixed(2) +
          '%';
      }
      return {
        buyMethod:
          actType === '1'
            ? '≥' + `${tieredMeasure}元`
            : actType === '2'
            ? '≥' + `${tieredMeasure}千克`
            : actType === '3'
            ? '≥' + `${tieredMeasure}箱`
            : actType === '4'
            ? '≥' + `${tieredMeasure}支`
            : null,
        price: lastPrice,
        discountPoint,
      };
    };

    return (
      <div className="searchTable">
        <Table
          className="tm-table fixed-table-column searchTable"
          loading={loading}
          rowKey="rowKey"
          dataSource={dataSource}
          footer={isLoginIn ? RenderFooter : null}
          pagination={pagination}
          locale={locale}
          onChange={(pagination, filters, sorter) => handleChange(pagination, filters, sorter)}
          onRow={(record) => {
            return {
              onMouseEnter: (e) => {
                if (asserts.isArray(record.instantMultiList)) {
                  const extraRow = document.querySelector(
                    `.searchTable .ant-table-body .ant-table-tbody [data-row-key='${record.rowKey}-extra-row']`,
                  );
                  if (extraRow) {
                    extraRow.childNodes.forEach((node) => {
                      node.className = 'expandRowColorHoverEnter';
                    });
                  }
                }
              },
              onMouseLeave: (e) => {
                if (asserts.isArray(record.instantMultiList)) {
                  const extraRow = document.querySelector(
                    `.searchTable .ant-table-body .ant-table-tbody [data-row-key='${record.rowKey}-extra-row']`,
                  );
                  if (extraRow) {
                    extraRow.childNodes.forEach((node) => {
                      node.className = 'expandRowColorHoverLeave';
                    });
                  }
                }
              },
            };
          }}
        >
          <Column
            title="材质"
            dataIndex="ibsrp3Dl01"
            align="center"
            className="material promotionImg"
            render={(text, record) => {
              const {
                scDay,
                scDelivery,
                scRemark,
                iconScope,
                inventory,
                iconScopeMoqnum,
                scStatus,
                saleUomInventory,
                isSpecial,
                isDiscount,
                disAcLabel,
                instantRebateFlag,
                instantMultiList,
                itemAcLabel,
                originalAmt,
                actBeginTime,
                actEndTime,
                mcuDiscount,
                promotionLabelEnable,
              } = record;
              const { min } = generateSpecialParams(record);
              const showIconMinNumber = !!iconScope ? iconScope : iconScopeMoqnum * min;
              const showIcon = showIconMinNumber >= saleUomInventory;
              const deliveryContent = `${scDelivery}` === '0' ? '，请联系客服确认交期' : '';
              //交期文案
              const deliveryDayContent = !!scDay ? `，预计交期${scDay}天` : deliveryContent;
              return (
                <>
                  <div className="preOrder-wrapper">
                    {scStatus && showIcon && (
                      <Tooltip
                        overlayClassName="table-item-tip remark-tip custom-order-tip"
                        // visible={true}
                        title={
                          <div className="text-error">
                            <span>支持预定{deliveryDayContent}</span>
                            {scRemark && <span>，{scRemark}</span>}
                          </div>
                        }
                        placement="bottomLeft"
                      >
                        <img alt="加载中..." src={preOrderImg} style={{ width: 16, height: 16 }} />
                      </Tooltip>
                    )}
                    <span
                      className={
                        ['316', '316L', '316L(Ni10)'].includes(text)
                          ? 'text-red material-content'
                          : 'material-content'
                      }
                      style={{
                        marginLeft: filterData.length > 0 ? (scStatus && showIcon ? 0 : 16) : 0,
                      }}
                    >
                      {text}
                    </span>
                  </div>
                  {promotionLabelEnable === '1' ? (
                    <div className="discount-time-d">
                      <p>促销中</p>
                      {actBeginTime && actEndTime ? (
                        <div style={{ fontSize: 12 }}>
                          <span>{actBeginTime ? moment(actBeginTime).format('MM.DD') : null}</span>
                          <span>~</span>
                          <span>{actEndTime ? moment(actEndTime).format('MM.DD') : null}</span>
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                </>
              );
            }}
          />
          <Column
            title="标准"
            dataIndex="ibsrp7Dl01"
            align="center"
            className="standard"
            render={(text) => {
              if (!isExist(text)) return null;
              return <span className={includes('912半牙', text) ? 'text-red' : ''}>{text}</span>;
            }}
          />
          <Column
            title="品名"
            dataIndex="imdsc2"
            align="center"
            width={100}
            className="name"
            // render={(text, record, index) => {
            //   if (!isExist(text)) return null;
            //   return (
            //     <>
            //       <span>{text}</span>
            //       <Popover
            //         placement="bottom"
            //         // visible={index === 0 ? true : false}
            //         overlayClassName="imdsc2-popover"
            //         content={
            //           <div className="imdsc2-popover-content">
            //             <div style={{ textAlign: 'center' }}>品质说明</div>
            //             <div>
            //               <p>认证体系</p>
            //               <span style={{ fontSize: 12 }}>ISO9001</span>
            //             </div>
            //             <div>
            //               <p>商品属性</p>
            //               <Row>
            //                 <Col span={12}>尺寸符合标准</Col>
            //                 <Col span={12}>国家标准</Col>
            //                 <Col span={12}>尺寸符合标准</Col>
            //                 <Col span={12}>国家标准</Col>
            //                 <Col span={12}>尺寸符合标准</Col>
            //                 <Col span={12}>国家标准</Col>
            //                 <Col span={12}>尺寸符合标准</Col>
            //                 <Col span={12}>国家标准</Col>
            //               </Row>
            //             </div>
            //           </div>
            //         }
            //       >
            //         <div className="pinzhi pointer">
            //           <span>品质：</span>
            //           <span>
            //             <span>通规:≥98%</span>
            //             <span>止规:≥98%</span>
            //           </span>
            //         </div>
            //       </Popover>
            //     </>
            //   );
            // }}
          />
          <Column
            title={
              <>
                <span className="tm-table-title-wrapper">项目号</span>
                {isLoginIn ? <span>图纸栏</span> : null}
              </>
            }
            width={72}
            align="center"
            dataIndex={isSpecialOffer ? 'itm' : 'teitm'}
            className="img"
            render={(text, record) => (
              <>
                <div>{text}</div>
                {isLoginIn ? (
                  <>
                    <span className="text-link" onClick={() => handleDrafting(record)}>
                      图纸
                    </span>
                    <span style={{ color: '#bbb' }}>&nbsp;|&nbsp;</span>
                    <span className="text-link" onClick={() => handleImgsClick(record)}>
                      图片
                    </span>
                  </>
                ) : null}
              </>
            )}
          />
          <Column title="规格" dataIndex="imdsc1" align="center" className="spec" />
          <Column
            title="印记"
            dataIndex="ibsrp8Dl01"
            align="center"
            className="imprinting"
            render={(text) => {
              if (!isExist(text)) return null;
              return (
                <span
                  className={includes('A2-80', text) || includes('A4-80', text) ? 'text-red' : ''}
                >
                  {text}
                </span>
              );
            }}
          />
          <Column
            title={
              <>
                <span className="tm-table-title-wrapper">牙别</span>
                <span>表面处理</span>
              </>
            }
            dataIndex="ibsrp5Dl01"
            align="center"
            className="treament"
            render={(text, record) => {
              const { ibsrp7 } = record;
              let className = '';
              if (text) {
                if (`${record.scatId}` === '3') {
                  if (!includes('粗牙', text)) {
                    className = 'text-red';
                  }
                } else {
                  if (['D09121', 'A18214', 'A01833'].includes(ibsrp7) && text === '半牙') {
                    className = 'text-red';
                  }
                }
              }
              return (
                <>
                  <div className={className}>{text}</div>
                  <div>{record.ibsrp9Dl01}</div>
                </>
              );
            }}
          />
          <Column
            title={
              <>
                <div>包装</div>
                <div>规格</div>
              </>
            }
            dataIndex="packspec"
            align="center"
            className="packSpec"
            render={(text, record) => {
              if (!text) return null;
              return text.split('<BR />').map((item) => <div key={item}>{item}</div>);
            }}
          />
          <Column
            title="仓别"
            dataIndex="mcuName"
            align="center"
            className="warehouse"
            render={(text, record, index) => {
              const { custItemLabel } = record;
              let labelHtml = asserts.isExist(custItemLabel)
                ? custItemLabel.cateMcuLabel && !custItemLabel.itemMcuLabel
                  ? custItemLabel.cateMcuLabel
                  : !custItemLabel.cateMcuLabel && custItemLabel.itemMcuLabel
                  ? custItemLabel.itemMcuLabel
                  : custItemLabel.cateMcuLabel && custItemLabel.itemMcuLabel
                  ? custItemLabel.cateMcuLabel + custItemLabel.itemMcuLabel
                  : null
                : null;
              return (
                <>
                  <div>{text}</div>
                  {!isSpecialOffer && !isIndustryZone && labelHtml ? (
                    <div
                      style={{ display: 'inline-block' }}
                      dangerouslySetInnerHTML={{ __html: labelHtml }}
                    />
                  ) : null}
                </>
              );
            }}
          />
          <Column
            title="库存量"
            align="right"
            // dataIndex={isSpecialOffer ? 'inventory' : 'saleUomInventory'}
            dataIndex="saleUomInventory"
            className="inventory"
            render={(text, record, index) => {
              if (isHavingInventory === 'N' || !isLoginIn) return <>会员可见</>;
              if (isHavingInventory === 'Y') {
                let visible;
                let textColor;
                const {
                  cartItemQty,
                  amStatus,
                  stockStatus,
                  saleUomMoqnum,
                  saleUomFlag,
                  custItemLabel,
                  upCartItemQty,
                  moq,
                  moqnum,
                  unPackFlag,
                } = record; //amStatus：是否配置了有货提醒
                let qty = cartItemQty || upCartItemQty; // 行上的值或者上边框里的值
                if (saleUomFlag !== '1') {
                  visible = getInventoryVisible(record);
                  const min = isSpecialOffer ? moq : moqnum;
                  // return (inventory < cartItemQty && !scStatus && !!min) || !!isNotPack;
                  let pcs = qty; // 出货量
                  if (upCartItemQty) {
                    // 从上边输入 出货量为 输入的值
                    if (!unPackFlag && qty % text !== 0) {
                      const maxMul = Math.ceil(qty / min);
                      pcs = maxMul * min;
                    }
                  } else {
                    // 从下面输入的值 都不能拆散
                    if (unPackFlag || (!unPackFlag && qty % text !== 0)) {
                      const maxMul = Math.ceil(qty / min);
                      pcs = maxMul * min;
                    }
                  }
                  textColor = visible || text < pcs ? '#e60101' : '#444';
                } else {
                  visible = text < mul(qty || 0, saleUomMoqnum);
                  textColor = visible ? '#e60101' : '#444';
                }
                const { isSpecial, custInstantRebate = {}, inventory, saleUomInventory } = record;
                return (
                  <div>
                    {!isSpecialOffer &&
                    !isIndustryZone &&
                    asserts.isExist(custItemLabel) &&
                    custItemLabel.itemInvLabel ? (
                      <div dangerouslySetInnerHTML={{ __html: custItemLabel.itemInvLabel }} />
                    ) : null}
                    <Tooltip
                      visible={visible}
                      title="库存不足"
                      overlayClassName="table-item-tip custom-order-tip"
                    >
                      <Statistic
                        valueStyle={{ color: textColor }}
                        value={
                          isSpecial === 'Y' || asserts.isExist(custInstantRebate)
                            ? saleUomInventory
                            : saleUomFlag !== '1'
                            ? text || 0
                            : formatToFixed2(text || 0)
                        }
                      />
                    </Tooltip>
                    <div>
                      <Tooltip
                        title="有货提醒"
                        overlayClassName="table-desc-tip custom-order-tip"
                        placement="bottomRight"
                      >
                        {`${text}` === '0' && amStatus && (
                          <span onClick={() => handleShowRemind(record, '0')}>
                            <img src={clockImg} style={{ width: 15, height: 15 }} alt="加载中..." />
                          </span>
                        )}
                      </Tooltip>
                      {`${text}` === '0' && stockStatus && amStatus && <Divider type="vertical" />}
                      <Tooltip
                        title="建议备货"
                        overlayClassName="table-desc-tip custom-order-tip"
                        placement="bottom"
                      >
                        {`${text}` === '0' && stockStatus && (
                          <span onClick={() => handleShowRemind(record, '1')}>
                            <img src={stockImg} style={{ width: 15, height: 15 }} alt="加载中..." />
                          </span>
                        )}
                      </Tooltip>
                    </div>
                  </div>
                );
              }
            }}
          />

          <Column
            title={
              <>
                <div>现货</div>
                <div>起订量</div>
              </>
            }
            // dataIndex={isSpecialOffer ? 'moq' : 'moqnum'}
            dataIndex={isSpecialOffer ? 'moq' : 'saleUomMoq'}
            className="min"
            align="center"
            render={(text, record, index) => {
              const {
                scStatus,
                scMoq,
                scMoqnum,
                saleUom,
                moqnum,
                saleUomDesc,
                saleUomFlag,
                saleUomMoqnum,
                weight,
                inventory,
              } = record; //stockStatus：是否配置了建议备货
              const visible = isSpecialOffer ? getSpecialVisible(record) : getMinVisible(record);
              const { min } = generateSpecialParams(record); //获取起订量
              const hasShortage = !!scMoq || !!scMoqnum;
              const scMin = !!scMoq ? scMoq : scMoqnum * min;
              const minValue = scStatus
                ? hasShortage
                  ? saleUom === 'MP' || saleUom === 'PC'
                    ? scMin
                    : formatToFixed2(scMin * weight)
                  : min
                : min; //如果配置了缺货，显示缺货起订量
              return (
                <>
                  <Tooltip
                    visible={visible}
                    title="商品起订量未维护，请联系客服"
                    overlayClassName="table-item-tip custom-order-tip"
                  >
                    {saleUomFlag !== '1' ? (
                      saleUom === 'MP' || saleUom === 'PC' ? (
                        <span>{minValue && `${formatNumber(minValue)}支`}</span>
                      ) : (
                        <span>{minValue && `${formatNumber(minValue)}${saleUomDesc}`}</span>
                      )
                    ) : (
                      <span>{saleUomMoqnum && `${formatNumber(saleUomMoqnum)}${saleUomDesc}`}</span>
                    )}
                  </Tooltip>
                  {!isSpecialOffer && !isIndustryZone && inventory <= 1 && scMin ? (
                    <div className="text-error">
                      <img alt="加载中..." src={preOrderImg} style={{ width: 16, height: 16 }} />
                      <span>{scMin}支</span>
                    </div>
                  ) : null}
                </>
              );
            }}
          />
          <Column
            title="需求量"
            dataIndex="cartItemQty"
            align="center"
            className="itemQty"
            render={(text, record, index) => {
              const visible = getQtyVisible(record);
              const { packspec } = record;
              if (!isSpecialOffer && !isIndustryZone) {
                return (
                  <>
                    <div style={{ whiteSpace: 'nowrap', marginBottom: 2 }}>
                      <PopUp
                        key={index}
                        visible={
                          index === key && asserts.isExist(packspec) ? cartItemQtyVisible : false
                        }
                        title={getTitle(index, record)}
                        placement="topLeft"
                        onVisibleChange={(visible) =>
                          onCartQtyVisibleChange(index, record, visible)
                        }
                        overlayClassName={'specialUser-hiddenBtns'}
                      >
                        {/* <Tooltip
                          visible={visible}
                          title="请输入数量"
                          overlayClassName="table-item-tip custom-order-tip"
                          placement="bottom"
                        > */}
                        <InputNum
                          placeholder="0"
                          value={text}
                          style={{ width: 60, padding: 4 }}
                          maxLength={8}
                          onChange={(val) => handleQuanChange(record, val, index)}
                          onBlur={() => handleBlur(record)}
                        />
                        {/* </Tooltip> */}
                      </PopUp>
                    </div>
                  </>
                );
              } else {
                return (
                  <div style={{ whiteSpace: 'nowrap', marginBottom: 2 }}>
                    <Tooltip
                      visible={visible}
                      title="请输入数量"
                      overlayClassName="table-item-tip custom-order-tip"
                    >
                      <InputNum
                        placeholder="0"
                        value={text}
                        style={{ width: 60, padding: 4 }}
                        maxLength={8}
                        onChange={(val) => handleQuanChange(record, val, index)}
                        onBlur={() => handleBlur(record)}
                      />
                    </Tooltip>
                  </div>
                );
              }
            }}
          />
          <Column
            title="出货量"
            dataIndex="pcs"
            align="center"
            className="pcs"
            render={(text, record) => {
              // if (
              //   record.saleUomFlag === '1' &&
              //   record.isSpecial !== 'Y' &&
              //   !asserts.isExist(record.custInstantRebate || {})
              // ) {
              //   return <div style={{ width: 75 }}>{text}</div>;
              // }
              if (record.saleUomFlag === '1') {
                return <div style={{ width: 70 }}>{text}</div>;
              }
              if (!asserts.isArray(text)) {
                return <div style={{ width: 70 }}>0</div>;
              }
              return text.map((item, index) => (
                <div key={index} style={{ width: 70 }}>
                  {item}
                </div>
              ));
            }}
          />
          <Column
            title="单位"
            dataIndex="saleUomDesc"
            align="center"
            className="saleUomDesc"
            render={(text, record) => {
              // if (
              //   record.saleUomFlag === '1' &&
              //   record.isSpecial !== 'Y' &&
              //   !asserts.isExist(record.custInstantRebate || {})
              // ) {
              //   return <div style={{ width: 50 }}>{text}</div>;
              // } else {
              //   return <div style={{ width: 50 }}>千支</div>;
              // }
              return <div style={{ width: 50 }}>{text}</div>;
            }}
          />
          <Column
            title="价格"
            dataIndex="teuncs"
            align="right"
            className={isSpecialUser ? 'column-hidden price' : 'price'}
            render={(text, record, index) => {
              if (isHavingPrice === 'N' || !isLoginIn)
                return (
                  <span className="link-underline" onClick={() => auth.showAuthModal()}>
                    会员价
                  </span>
                );
              if (!isExist(text)) return null;
              if (isHavingPrice === 'Y') {
                const visible = getPriceVisible(record);
                const {
                  isSpecial,
                  isDiscount,
                  isMemberRate,
                  originalAmt,
                  instantRebateFlag,
                  custInstantRebateNew = [],
                  custInstantRebate = {},
                  instantMultiList = [],
                  specialAcLabel,
                  itemAcLabel,
                  rebateAcLabel,
                  disAcLabel,
                  memberRebateLabel,
                  isFixedPrice,
                  fixedPriceLabel,
                  disPoint,
                  bottomTeuncs,
                } = record;
                const newActivityList =
                  !isSpecialOffer && !isIndustryZone && record ? getActivityList(record) : [];
                const title = (
                  <>
                    <div className="align-center text-bolder">满减活动</div>
                    {asserts.isExist(custInstantRebateNew) &&
                      custInstantRebateNew.length > 0 &&
                      custInstantRebateNew.map((item) => {
                        return <div className="remark-main">{generatorObject(item).remark}</div>;
                      })}
                    {asserts.isExist(instantMultiList) &&
                      instantMultiList.length > 0 &&
                      instantMultiList.map((item) => {
                        return (
                          <div className="remark-main">{generatorObject(item).detailRemark}</div>
                        );
                      })}
                  </>
                );
                return (
                  <>
                    <div>
                      {isSpecial === 'Y' || isSpecialOffer ? (
                        specialAcLabel ? (
                          <div
                            style={{ display: 'inline-block' }}
                            dangerouslySetInnerHTML={{ __html: specialAcLabel }}
                          />
                        ) : (
                          <span className="text-red text-bolder" style={{ marginRight: 4 }}>
                            特
                          </span>
                        )
                      ) : null}
                      {(isDiscount === 'Y' && !asserts.isExist(disAcLabel)) ||
                      (isMemberRate === 'Y' && !asserts.isExist(memberRebateLabel)) ? (
                        <span className="text-red text-bolder" style={{ marginRight: 4 }}>
                          折
                        </span>
                      ) : null}
                      {asserts.isExist(disAcLabel) ? (
                        <div
                          style={{ display: 'inline-block' }}
                          dangerouslySetInnerHTML={{ __html: disAcLabel }}
                        />
                      ) : null}
                      {asserts.isExist(memberRebateLabel) ? (
                        <div
                          style={{ display: 'inline-block' }}
                          dangerouslySetInnerHTML={{ __html: memberRebateLabel }}
                        />
                      ) : null}
                      {isFixedPrice === 'Y' ? (
                        asserts.isExist(fixedPriceLabel) ? (
                          <div
                            style={{ display: 'inline-block' }}
                            dangerouslySetInnerHTML={{ __html: fixedPriceLabel }}
                          />
                        ) : (
                          <span className="text-red text-bolder" style={{ marginRight: 4 }}>
                            促
                          </span>
                        )
                      ) : null}
                      {instantRebateFlag === '1' || asserts.isExist(instantMultiList) ? (
                        rebateAcLabel ? (
                          <Tooltip
                            overlayClassName="table-item-tip remark-tip custom-order-tip"
                            placement="bottomLeft"
                            title={title}
                          >
                            <div
                              style={{ display: 'inline-block' }}
                              dangerouslySetInnerHTML={{ __html: rebateAcLabel }}
                            />
                          </Tooltip>
                        ) : (
                          <Tooltip
                            overlayClassName="table-item-tip remark-tip custom-order-tip"
                            placement="bottomLeft"
                            title={title}
                          >
                            {/* <Statistic
                          value={formatPrice(text)}
                          prefix={
                            <>
                              <span className="text-red text-bolder">惠</span>
                            </>
                          }
                        /> */}
                            <span className="text-red text-bolder">惠</span>
                          </Tooltip>
                        )
                      ) : null}
                    </div>
                    <Tooltip
                      visible={visible}
                      title="商品价格未配置,请联系客服"
                      overlayClassName="table-item-tip custom-order-tip"
                    >
                      <Statistic value={formatPrice(text)} />
                      {/* {!asserts.isExist(custInstantRebate) && <Statistic value={formatPrice(text)} />} */}
                      {!!originalAmt && (
                        <div className="text-lineThrough">{formatPrice(originalAmt)}</div>
                      )}
                    </Tooltip>
                    {itemAcLabel ? (
                      <div
                        style={{ display: 'inline-block' }}
                        dangerouslySetInnerHTML={{ __html: itemAcLabel }}
                      />
                    ) : null}
                    {!isSpecialOffer && !isIndustryZone && disPoint ? (
                      <div className="price-discount">
                        <span>促销</span>
                        <span>
                          降
                          {maths.mul(disPoint || 0, 100) % 1 === 0
                            ? maths.mul(disPoint || 0, 100)
                            : formatToFixed2(maths.mul(disPoint || 0, 100))}
                          点
                        </span>
                      </div>
                    ) : null}
                    {!isSpecialOffer &&
                    !isIndustryZone &&
                    bottomTeuncs &&
                    newActivityList.length ? (
                      <Popover
                        placement="bottom"
                        onVisibleChange={(visible) => getActivityVisible(index, visible)}
                        // visible={index===7?true:false}
                        overlayClassName="dpd-popover"
                        content={
                          <div className="dpd-popover-content">
                            <img
                              src={`${process.env.TARGET}static/imgs/discount7.png`}
                              alt=""
                              width={300}
                              // height={50}
                            />
                            {newActivityList.map((item, index) => {
                              let desc = '单价立减';
                              let filterList = sysList.filter((itm) =>
                                item.activity === 'MCU'
                                  ? itm.confCode === 'mcuActivityDesc'
                                  : item.activity === 'DIS'
                                  ? itm.confCode === 'disActivityDesc'
                                  : item.activity === 'FIXED'
                                  ? itm.confCode === 'fixedActivityDesc'
                                  : item.activity === 'SPECIAL'
                                  ? itm.confCode === 'specialActivityDesc'
                                  : null,
                              );
                              if (filterList.length) {
                                desc = filterList[0].confValue;
                              }
                              return (
                                <>
                                  <p className="dpd-popover-title">
                                    {index + 1}.{item.activityName}
                                  </p>
                                  {item.activityFlag ? (
                                    <Table
                                      className="dpd-table tm-table"
                                      dataSource={item.dataSource}
                                      pagination={false}
                                      bordered
                                      columns={[
                                        {
                                          title: '购买条件',
                                          dataIndex: 'buyMethod',
                                          key: 'buyMethod',
                                          align: 'left',
                                        },
                                        {
                                          title: '单价',
                                          dataIndex: 'price',
                                          key: 'price',
                                          align: 'left',
                                          render: (value) => {
                                            return <span>￥{value}/千支</span>;
                                          },
                                        },
                                        {
                                          title: '浮动',
                                          dataIndex: 'discountPoint',
                                          key: 'discountPoint',
                                          align: 'left',
                                        },
                                      ]}
                                    />
                                  ) : (
                                    <p>
                                      {desc}
                                      {item.discount}%
                                    </p>
                                  )}
                                </>
                              );
                            })}
                          </div>
                        }
                      >
                        <div className="lowPrice pointer">
                          <span>可低至</span>
                          <span className="text-error">￥{bottomTeuncs}/千支</span>
                          <Icon
                            type={index === key && activityVisible ? 'up' : 'down'}
                            style={{ fontSize: 12, color: '#f5222d' }}
                          />
                        </div>
                      </Popover>
                    ) : null}
                  </>
                );
              }
            }}
          />
          <Column
            title="收藏/自定义"
            dataIndex="setting"
            align="center"
            className="operation"
            render={(text, record, index) =>
              isHavingCust === 'Y' && (
                <>
                  {asserts.isExist(record.custInstantRebate || {}) && !!record.lineAmt && (
                    <div className="search-table-lineAmt">
                      已选{formatToFixed2(record.lineAmt)}元
                    </div>
                  )}
                  <div style={{ cursor: 'pointer' }}>
                    <PopUp
                      title={collectTitle}
                      placement="topRight"
                      visible={index === key ? collectVisible : false}
                      onConfirm={() => handleCollectConfirm(record)}
                      onCancel={handleCollectCancel}
                      onVisibleChange={(visible) => onCollectVisibleChange(index, visible)}
                    >
                      <Tooltip
                        overlayClassName="table-desc-tip custom-order-tip"
                        placement="bottom"
                        title="收藏"
                      >
                        <Icon
                          type="star"
                          theme={record.collection ? 'filled' : 'outlined'}
                          className="ant-item-cart"
                        />
                      </Tooltip>
                    </PopUp>

                    <Divider type="vertical" className="operation-divider" />
                    <PopUp
                      title={customTitle}
                      placement="leftTop"
                      visible={index === key ? customVisible : false}
                      destroyTooltipOnHide={false}
                      onConfirm={() => handleCustomConfirm(record)}
                      onCancel={handleCustomCancel}
                      onVisibleChange={(visible) => onCustomVisibleChange(record, index, visible)}
                      overlayClassName={
                        isSpecialUser
                          ? 'specialUser-hiddenBtns custom-code-popover'
                          : 'custom-code-popover'
                      }
                    >
                      <Tooltip
                        overlayClassName="table-desc-tip custom-order-tip"
                        placement="bottom"
                        title="自定义"
                      >
                        <Icon
                          type="setting"
                          theme={record.userCode ? 'filled' : 'outlined'}
                          className="ant-item-cart"
                        />
                      </Tooltip>
                    </PopUp>
                  </div>
                </>
              )
            }
          />
          <Column
            title="购买"
            dataIndex="userCart"
            align="center"
            className={isSpecialUser ? 'column-hidden buying' : 'buying'}
            render={(_, record, index) => {
              const visible = getCartTipVisible(record);
              const { userCart, aaenable, addCarFlagDesc } = record; //aaenable : 是否可出货
              if (isHavingCust !== 'Y' || `${aaenable}` !== '1') return null;
              return (
                <div style={{ display: 'flex' }}>
                  <Tooltip
                    visible={visible}
                    title={addCarFlagDesc}
                    overlayClassName="table-item-tip custom-order-tip"
                  >
                    <Tooltip
                      title="购买"
                      overlayClassName="table-desc-tip custom-order-tip"
                      placement="bottom"
                    >
                      <span
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          // record.saleUomFlag === '1' &&
                          // record.isSpecial !== 'Y' &&
                          // !asserts.isExist(record.custInstantRebate || {})
                          //   ? handleSalesUomBuying(record)
                          //   : handleBuying(record);
                          handleBuying(record);
                        }}
                      >
                        <img
                          style={{ width: 17.5, height: 17.5 }}
                          alt="加载中..."
                          src={userCart ? hasShop : noShop}
                        />
                      </span>
                    </Tooltip>
                  </Tooltip>
                  <PopUp
                    title={stockTitle}
                    placement="topRight"
                    visible={index === key ? stockVisible : false}
                    onConfirm={() => handleLineStockConfirm(record)}
                    onCancel={handleLineStockCancel}
                    onVisibleChange={(visible) => onLineStockVisibleChange(index, visible)}
                    okText="加车"
                  >
                    <Tooltip
                      overlayClassName="table-desc-tip custom-order-tip"
                      placement="bottom"
                      title="拆分标识"
                    >
                      <Icon type="caret-down" />
                    </Tooltip>
                  </PopUp>
                </div>
              );
            }}
          />
        </Table>
        {modalVisible ? (
          <DrawlingModal
            modalVisible={modalVisible}
            material={record.ibsrp3Dl01}
            standard={record.ibsrp7Dl01}
            spec={record.imdsc1}
            projectNo={isSpecialOffer ? record.itm : record.teitm}
            name={record.imdsc2}
            ibsrp5Dl01={record.ibsrp5Dl01}
            ibsrp9Dl01={record.ibsrp9Dl01}
            ibsrp7={record.ibsrp7}
            scatId={record.scatId}
            pcatId={record.pcatId}
            weight={record.weight}
            onCancel={handleCancel}
            currentValue={'1'}
          />
        ) : null}
        {/* {imgsModalVisible ? (
          <ImgsModal
            modalVisible={imgsModalVisible}
            material={record.ibsrp3Dl01}
            standard={record.ibsrp7Dl01}
            spec={record.imdsc1}
            projectNo={isSpecialOffer ? record.itm : record.teitm}
            name={record.imdsc2}
            handleCancel={handleImgsModalCancel}
            imgs={imgs}
          />
        ) : null} */}
        {imgsModalVisible ? (
          <DrawlingModal
            modalVisible={imgsModalVisible}
            material={record.ibsrp3Dl01}
            standard={record.ibsrp7Dl01}
            spec={record.imdsc1}
            projectNo={isSpecialOffer ? record.itm : record.teitm}
            name={record.imdsc2}
            ibsrp5Dl01={record.ibsrp5Dl01}
            ibsrp9Dl01={record.ibsrp9Dl01}
            ibsrp7={record.ibsrp7}
            scatId={record.scatId}
            pcatId={record.pcatId}
            weight={record.weight}
            onCancel={handleImgsModalCancel}
            currentValue={'2'}
          />
        ) : null}

        <RemindModal
          visible={remindVisible}
          days={days}
          number={number}
          defaultMobile={principal.mobile}
          selectedValue={selectedItem}
          handleHide={handleHideRemind}
        />
        <PreparatifsModal
          visible={prepareVisible}
          days={days}
          number={prepareNumber}
          defaultMobile={principal.mobile}
          selectedValue={selectedItem}
          handleHide={handleHidePrepare}
        />
        <div id="pinzhi" style={{ display: 'none' }}>
          <Icon type="down" />
        </div>
      </div>
    );
  },
);
